import { LoginResponse } from "../../generated/openapi-codegen/ob-software/station-display/station-display-auth/models/LoginResponse";
import { AUTH_TOKEN_KEY } from "./constants";

const getTokens = (): LoginResponse | null => {
	const authTokens = window.localStorage.getItem(AUTH_TOKEN_KEY);
	if (!authTokens) {
		return null;
	}

	try {
		return JSON.parse(authTokens) as LoginResponse;
	} catch (error) {
		console.error("Failed to parse auth tokens:", error);
		return null;
	}
};

export const formatBearerToken = (token: string): string => {
	return `Bearer ${token}`;
};

export const getBearerToken = (): string => {
	const tokens = getTokens();
	if (!tokens) return "";

	return formatBearerToken(tokens.access_token);
};

export const getIsPasswordExpired = (): boolean => {
	const tokens = getTokens();
	if (!tokens) return false;

	return tokens.password_to_reset;
};
